document.addEventListener("DOMContentLoaded", function () {
  // Initialize PhotoSwipe for all product gallery types
  const gallerySelectors = [
    '.product-gallery',
    '.product__gallery-main',
    '.product__gallery--grid',
    '.product__gallery--default'
  ];

  gallerySelectors.forEach(selector => {
    const gallery = document.querySelector(selector);
    if (gallery) {
    const lightbox = new PhotoSwipeLightbox({
        gallery: selector,
        children: 'a[data-pswp-width]',
        pswpModule: PhotoSwipe,
    });
    lightbox.init();
    }
  });
  });
  